import { defineStore } from 'pinia'

import type { CommonStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useCommonStore = defineStore('common', {
  state: (): CommonStore => ({
    loading: false,
    notification: {
      show: false,
      title: '',
      description: '',
      mode: 'info',
    },
    informationBanner: {
      information_banner_is_demo: false,
      information_banner_is_paid: false,
      information_banner_text: '',
      information_banner_title: '',
    },
    noScroll: false,
    modalShowed: false,
  }),
  actions,
  getters,
})
